module.exports = {
    "collectionLabel": `Prijedlozi`
};


//# sourceMappingURL=hr-HR.main.js.map
